import ObjectBuilderInterface from "@/modules/api/object-builder.interface";

import FactoryRushCapacityType from "./factory-rush-capacity-type.model";

export default class FactoryRushCapacityTypeFactory
  implements ObjectBuilderInterface<FactoryRushCapacityType> {
  public buildFromJSON(data: { [key: string]: any }): FactoryRushCapacityType {
    const value = new FactoryRushCapacityType(data.id, data.code);

    (value as any).fCreatedAt = new Date(data.createdAt);

    value.isNew = false;

    return value;
  }
}
